import { bare } from './axiosApi'

/**
 * Login with email and password credentials
 */
export async function login(email: string, password: string) {
  const form = new URLSearchParams()
  form.append('grant_type', 'password')
  form.append('username', email)
  form.append('password', password)

  const response = await bare.post('/auth/login', form, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: 'Basic Og==',
    },
  })

  return response.data
}
